// What the tracking export reads besides the board (root-f5, 2026-09-18):
// root-8e's per-node status totals and the tracked buckets, fetched with
// the same scope and files as the tree so the file and the screen agree.
import { url, tokenRef } from "api";

const headers = () => ({ Authorization: `Bearer ${localStorage.getItem(tokenRef)}` });
const qs = (p) => {
  const e = Object.entries(p || {}).filter(([, v]) => v !== undefined && v !== null && v !== "");
  return e.length ? `?${e.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join("&")}` : "";
};
const get = async (path) => {
  const res = await fetch(`${url}${path}`, { headers: headers() });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.err || "Request failed");
  return body;
};

export const getStatusTotals = (projectId, params) => get(`/projects/${projectId}/field-tracking/elements/status-totals${qs(params)}`);
export const getTrackedBuckets = (projectId, params) => get(`/projects/${projectId}/tracked-buckets${qs(params)}`);
